var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5043 14.1667C13.5838 14.1667 12.8376 14.9129 12.8376 15.8333C12.8376 16.7538 13.5838 17.5 14.5043 17.5C15.4248 17.5 16.171 16.7538 16.171 15.8333C16.171 14.9129 15.4248 14.1667 14.5043 14.1667ZM14.5043 14.1667H8.0826C7.69838 14.1667 7.50592 14.1667 7.34774 14.0983C7.20819 14.038 7.08713 13.9409 6.99893 13.8171C6.90007 13.6783 6.8603 13.4928 6.7816 13.1254L4.73055 3.55387C4.65001 3.17803 4.6092 2.99031 4.5092 2.84993C4.42099 2.72612 4.29995 2.62868 4.16041 2.56837C4.00219 2.5 3.8108 2.5 3.42643 2.5H2.83765M5.33765 5H16.0653C16.6668 5 16.9673 5 17.1691 5.1253C17.346 5.23505 17.4754 5.40718 17.5319 5.6075C17.5963 5.83619 17.5135 6.12497 17.3468 6.70288L16.193 10.7029C16.0933 11.0484 16.0434 11.2209 15.9423 11.3491C15.853 11.4622 15.7353 11.5508 15.6019 11.6052C15.4511 11.6667 15.2719 11.6667 14.9144 11.6667H6.7797M7.00431 17.5C6.08384 17.5 5.33765 16.7538 5.33765 15.8333C5.33765 14.9129 6.08384 14.1667 7.00431 14.1667C7.92479 14.1667 8.67098 14.9129 8.67098 15.8333C8.67098 16.7538 7.92479 17.5 7.00431 17.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart01);
export default __webpack_public_path__ + "static/media/Shopping_Cart_01.ce6a499e3961c34b0e7013def47a44fc.svg";
export { ForwardRef as ReactComponent };